import { render, staticRenderFns } from "./NavigationLinkStartConfiguration.vue?vue&type=template&id=22d5ce7d"
import script from "./NavigationLinkStartConfiguration.vue?vue&type=script&lang=ts"
export * from "./NavigationLinkStartConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports